<template>
  <div>
    <div class="evaluate-item" v-for="(item,index) in evaluateList" :key="index">
      <div class="item-header">
        <div class="left-item">
          <img class="item-user-image" v-bind:src="item.headimgurl" alt="">
          <div class="item-user-name">{{item.userName}}</div>
          <van-rate color="#ee0a24" v-model="item.score" size="12" />
        </div>
        <div class="right-item evaluate-time">{{item.createAt | formatTime}}</div>
      </div>
      <div class="item-content over3line">
        {{item.content || '此用户未填写评价内容'}}
      </div>
      <div class="image-list" v-show="item.productEvaluatePictureList && item.productEvaluatePictureList.length > 0">
        <img class="image-item" @click="openImageList(item,index)" v-bind:src="img.picUrl" v-for="(img,index) in item.productEvaluatePictureList" alt="">
      </div>
      <!-- 规格 -->
      <div class="standard" v-show="item.productSpecificationsValue">
        规格：{{item.productSpecificationsValue}}
      </div>
    </div>
    <van-image-preview
      v-model="showImage"
      :images="images"
      :start-position="startIndex"
    >
    </van-image-preview>
  </div>
</template>

<script>
  export default {
    props: {
      evaluateList: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        showImage: false,
        images: [],
        startIndex: 0
      }
    },
    created() {
    },
    methods: {
      openImageList(item,index) {
        this.showImage = true;
        this.startIndex = index;
        this.images = item.productEvaluatePictureList.map(item=>item.picUrl);
      }
    },
    filters:{
      formatTime(val) {
        if (val.indexOf(' ') > -1) {
          return val.split(' ')[0];
        }else{
          return val
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import 'common/sass/theme.scss';
  .evaluate-item{
    padding: 10px;
    border-bottom: 1px solid $light-line-color;
    .item-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left-item{
        display: flex;
        align-items: center;
      }
      .item-user-image{
        float: left;
        display: inline-block;
        width: 25px;
        height: 25px;
        border-radius: 100%;
        overflow: hidden;
      }
      .item-user-name{
        float: left;
        font-size: 12px;
        margin: 0 3px 0 5px;
      }
      .evaluate-time{
        float: right;
        font-size: 12px;
        color: $lingt-word-color;
      }
    }
    .item-content{
      font-size: 14px;
      margin: 5px 0;
    }
    .image-item{
      display: inline-block;
      width: 75px;
      height: 75px;
      margin-right: 5px;
    }
    .standard{
      margin-top: 5px;
      font-size: 13px;
      color: $lingt-word-color;
    }
  }
</style>